// Mixpanel is initialized in index.html with autocapture and session recording
// This ensures it loads as early as possible to capture all interactions

// Type definition for window.mixpanel
declare global {
  interface Window {
    mixpanel: {
      init: (token: string, config?: Record<string, any>) => void;
      identify: (userId: string) => void;
      track: (eventName: string, properties?: Record<string, any>) => void;
      people: {
        set: (properties: Record<string, any>) => void;
        increment: (property: string, value?: number) => void;
      };
      reset: () => void;
    };
  }
}

// Mixpanel tracking service using the global instance from HTML
export const analytics = {
  // Identify user
  identify: (userId: string, traits?: Record<string, any>) => {
    if (window.mixpanel && window.mixpanel.identify) {
      window.mixpanel.identify(userId);
      if (traits && window.mixpanel.people) {
        window.mixpanel.people.set(traits);
      }
    }
  },

  // Track event
  track: (eventName: string, properties?: Record<string, any>) => {
    if (window.mixpanel && window.mixpanel.track) {
      window.mixpanel.track(eventName, properties);
    }
  },

  // Set user properties
  setUserProperties: (properties: Record<string, any>) => {
    if (window.mixpanel && window.mixpanel.people) {
      window.mixpanel.people.set(properties);
    }
  },

  // Increment a user property
  incrementUserProperty: (property: string, value: number = 1) => {
    if (window.mixpanel && window.mixpanel.people) {
      window.mixpanel.people.increment(property, value);
    }
  },

  // Track page view
  trackPageView: (pageName: string, properties?: Record<string, any>) => {
    if (window.mixpanel && window.mixpanel.track) {
      window.mixpanel.track('Page View', {
        page: pageName,
        ...properties,
      });
    }
  },

  // Reset on logout
  reset: () => {
    if (window.mixpanel && window.mixpanel.reset) {
      window.mixpanel.reset();
    }
  },
};

export default analytics;
